import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Ltp({ symbol_id, adv, digit }) {
  const socket = useContext(SocketContext);
  const [ltp, setLtp] = useState(0);

  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && typeof data.LTP !== "undefined") {
        setLtp(data.LTP);
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);
    return () => socket.off(`trade${symbol_id}`, tradeListener);
  }, [socket, symbol_id]);

  return (
    <span
      style={{ fontWeight: adv ? 700 : 600 }}
      className={`text-right transition-all duration-300 font-medium text-[var(--subtext)] ${
        adv ? "text-[10px]" : null
      }`}
    >
      {ltp}
    </span>
  );
}
